export default function StarredIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1.5 9C1.5 5.64124 1.5 3.96187 2.54343 2.91843C3.58687 1.875 5.26624 1.875 8.625 1.875C11.9837 1.875 13.6631 1.875 14.7066 2.91843C15.75 3.96187 15.75 5.64124 15.75 9C15.75 12.3587 15.75 14.0381 14.7066 15.0816C13.6631 16.125 11.9837 16.125 8.625 16.125C5.26624 16.125 3.58687 16.125 2.54343 15.0816C1.5 14.0381 1.5 12.3587 1.5 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.27285 5.79157L9.93278 7.12233C10.0228 7.30758 10.2628 7.48526 10.4652 7.51928L11.6614 7.71968C12.4263 7.84823 12.6062 8.40773 12.0551 8.95965L11.1251 9.8973C10.9677 10.0561 10.8815 10.3623 10.9302 10.5815L11.1964 11.7422C11.4064 12.6609 10.9227 13.0163 10.1165 12.5361L8.99543 11.867C8.79293 11.746 8.45918 11.746 8.253 11.867L7.13185 12.5361C6.32944 13.0163 5.84199 12.6571 6.05197 11.7422L6.31819 10.5815C6.36694 10.3623 6.2807 10.0561 6.12321 9.8973L5.19332 8.95965C4.64588 8.40773 4.8221 7.84823 5.58702 7.71968L6.78314 7.51928C6.98187 7.48526 7.22184 7.30758 7.31183 7.12233L7.97175 5.79157C8.33175 5.06948 8.91668 5.06948 9.27285 5.79157Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
